import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";

// REQ-394: one line for the Admin while Drive can't be read; the controls live on the Google Drive screen.
export const DriveNotice = () => {
  const [bad, setBad] = useState(false);
  useEffect(() => { api.get("/drive/status").then((r) => setBad(!!(r.data.unreadable || r.data.needs_reconnect))).catch(() => {}); }, []);
  if (!bad) return null;
  return (
    <div className="flex items-center gap-2 rounded-[14px] border border-[#f3c9c9] bg-[#fdf0ef] px-4 py-2.5 text-sm font-semibold text-[#b42318]" data-testid="drive-notice">
      <AlertTriangle className="h-4 w-4 shrink-0" /> No se pudo leer Google Drive ·
      <Link to="/google-drive" className="underline" data-testid="drive-notice-link">Ir a Google Drive</Link>
    </div>
  );
};
